import getBusinessTypeName from '../../getSteelMakerName';
import type { Language, ProcessCellCallbackParams, SelectOption, BusinessType } from '../../../types/common';
import type { OptionsType } from '../../../types/options';

const businessTypeCellCallback = (params: ProcessCellCallbackParams): string => {
  const value: BusinessType | BusinessType[] = params.value;
  const businessTypeCodes: BusinessType[] = Array.isArray(value) ? value : [value];
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const businessType: OptionsType<BusinessType>[] | undefined = params.context?.businessType;
  // 区分の配列を区分名の配列にマップする。マッチするものが見つからなかったらコードのままにする。
  const businessTypeNames: string[] = businessTypeCodes.map((code) => {
    const businessTypeName: string = getBusinessTypeName(code, businessType, currentLang.value);
    return businessTypeName;
  });
  const filterValue: string = businessTypeNames.join(', ');
  return filterValue;
};

export default businessTypeCellCallback;
